import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 30);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: "/", label: t("nav.home") },
    { to: "/category/muban-sucai", label: t("nav.categories") },
    { to: "/category/muban-sucai", label: t("nav.templates") },
    { to: "/category/shiyong-jiaocheng", label: t("nav.tutorials") },
    { to: "/about", label: t("nav.about") },
  ];

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 no-underline cursor-pointer"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-dribbble-line text-2xl" style={{ color: "oklch(var(--accent-500))" }}></i>
            </div>
            <span className="text-xl font-semibold whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
              黄油网站
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to + link.label}
                to={link.to}
                className={`relative text-sm whitespace-nowrap transition-colors duration-200 cursor-pointer no-underline ${
                  isActive(link.to)
                    ? "text-foreground-950 font-medium"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {link.label}
                {isActive(link.to) && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-4 h-0.5 rounded-full" style={{ backgroundColor: "oklch(var(--accent-500))" }}></span>
                )}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer bg-transparent border-none px-3 py-2 rounded-md whitespace-nowrap">
              {t("nav.login")}
            </button>
            <button className="text-sm text-background-50 px-4 py-2 rounded-md cursor-pointer whitespace-nowrap transition-all duration-200 hover:opacity-90" style={{ backgroundColor: "oklch(var(--accent-500))" }}>
              {t("nav.register")}
            </button>
          </div>

          <button
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer bg-transparent border-none"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={isMobileOpen ? "ri-close-line text-xl text-foreground-950" : "ri-menu-line text-xl text-foreground-950"}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to + link.label}
                to={link.to}
                className={`text-sm py-2 cursor-pointer no-underline ${
                  isActive(link.to) ? "text-foreground-950 font-medium" : "text-foreground-600"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-2 pt-2 border-t border-background-200/70">
              <button className="flex-1 text-sm text-foreground-600 py-2 rounded-md cursor-pointer bg-background-100 border-none whitespace-nowrap">
                {t("nav.login")}
              </button>
              <button className="flex-1 text-sm text-background-50 py-2 rounded-md cursor-pointer whitespace-nowrap" style={{ backgroundColor: "oklch(var(--accent-500))" }}>
                {t("nav.register")}
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}